import zxcvbn from 'zxcvbn'

export const passwordStrengthValidation = (value?: string) => {
  const { score } = zxcvbn(value || '')

  // The score should be at least 2 (Okay)
  return score > 1
}
